import { render } from "./App.vue?vue&type=template&id=730f8c4d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=730f8c4d&lang=less"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b3655c94b52f2edce08bd59b38cc948d/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__